'use strict';

angular.module('userRequestEditControllers')

.controller('DisplayArrivalInformationController', ['$scope', function ($scope) {

}]);